<template>
  <div>
    <v-card flat class="rounded-lg">
      <div class="pa-4 d-flex justify-center align-center">
        <div class="flex-column flex-grow-1">
          <template>
            <!-- media new-->
            <v-container v-if="mediaUrl && isEdit" fluid class="pa-0 mb-4">
              <VideoPlayer key="videoDataUrl" :mediaUrl="mediaUrl" />

              <v-row no-gutters justify="end" class="mt-2">
                <v-col cols="auto">
                  <v-btn
                    depressed
                    small
                    color="error"
                    min-width="80"
                    class="rounded-1"
                    :disabled="isMediaSaving"
                    @click="cancelMediaSelection"
                  >
                    {{ $t("course.courseDetails.cancel") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>

            <!--media existing-->
            <v-container
              v-else-if="
                hasContents(introVideoContent ? [introVideoContent] : [])
              "
              fluid
              class="pa-0 mb-4"
            >
              <VideoPlayer
                key="videoUrl"
                :mediaUrl="getVideo([introVideoContent])"
              />

              <v-row v-if="isEdit" no-gutters justify="end" class="mt-2">
                <v-col cols="auto">
                  <FileSelector accept="video/mp4" @onFileSelect="onFileSelect">
                    <template v-slot:element="{ onClick, loading }">
                      <v-btn
                        depressed
                        small
                        color="primary"
                        min-width="80"
                        :loading="loading"
                        @click="onClick"
                        class="rounded-1 me-2"
                      >
                        <v-icon left small color="white">mdi-pencil</v-icon>

                        {{ $t("course.courseDetails.edit") }}
                      </v-btn>
                      <v-btn
                        depressed
                        small
                        color="error"
                        min-width="80"
                        :loading="loading"
                        @click="onDelete"
                        class="rounded-1"
                      >
                        <v-icon left small color="white">mdi-delete</v-icon>

                        {{ $t("course.courseDetails.delete") }}
                      </v-btn>
                    </template>
                  </FileSelector>
                </v-col>
              </v-row>
            </v-container>

            <!-- media empty-->
            <v-container
              v-else
              fluid
              class="fill-height justify-center pa-0 mb-4"
              style="border: 1px solid #281166; border-radius: 7px"
              :style="`height: ${contentMediaHeight}px`"
            >
              <FileSelector
                :style="!isEdit ? 'pointer-events: none' : ''"
                accept="video/mp4"
                @onFileSelect="onFileSelect"
              >
                <template v-slot:element="{ onClick, loading }">
                  <v-btn
                    depressed
                    outlined
                    plain
                    color="textLight"
                    :loading="loading"
                    @click="onClick"
                    class="rounded-1 text-capitalize"
                    style="min-width: 120px; opacity: 0.5"
                  >
                    <v-icon left>mdi-upload-outline</v-icon>

                    {{ $t("course.courseDetails.uploadVideo") }}
                  </v-btn>
                </template>
              </FileSelector>
            </v-container>
          </template>
          <div class="d-flex justify-end">
            <float-btn
              :isEdit="isEdit"
              @save="onClick"
              @edit="isEdit = true"
              :bottom="true"
              :loading="isMediaSaving"
              class="me-9"
            />
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>
<script>
import FloatBtn from "../employee-profile/FloatBtn.vue";
import VideoPlayer from "../../../core-module/components/VideoPlayer.vue";
import FileSelector from "@/app/core-module/components/FileSelector";

import { createOrUpdateSubscriberProfile } from "../../methods/createOrUpdateSubscriberProfile";
export default {
  components: {
    VideoPlayer,
    FileSelector,
    FloatBtn,
  },
  props: {
    companyData: {
      type: Object,
      default: () => {},
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMediaSaving: false,
      introVideoContent: null,
      mediaUrl: null,
      mediaBlob: null,
      isEdit: false,
    };
  },
  watch: {
    companyData: {
      immediate: true,
      handler() {
        this.introVideoContent = this.companyData?.introVideos?.length
          ? this.companyData.introVideos[0]
          : null;
        // this.resetFormData();
      },
      deep: true,
    },
  },
  computed: {
    contentMediaHeight() {
      return this.$vuetify.breakpoint.xlOnly
        ? 400
        : this.$vuetify.breakpoint.lgAndUp
        ? 300
        : 250;
    },
  },
  methods: {
    resetFormData(data) {
      this.introVideoContent = data ? data : null;
      this.mediaUrl = null;
      this.mediaBlob = null;
    },
    onFileSelect(file) {
      this.mediaBlob = file.blob;
      this.mediaUrl = file.dataUrl;
    },
    cancelMediaSelection() {
      this.mediaBlob = null;
      this.mediaUrl = null;
    },
    onDelete() {
      this.resetFormData(null);
    },
    async onClick() {
      this.isEdit = false;

      if (this.mediaBlob instanceof Blob) {
        this.isMediaSaving = true;
        let saveData = {
          introVideos: [
            {
              lang: "en",
              url: this.mediaBlob,
            },
          ],
        };
        this.createOrUpdate(saveData);
      } else if (!this.introVideoContent) {
        let saveData = {
          introVideos: [],
        };
        this.createOrUpdate(saveData);
      }
    },
    async createOrUpdate(data) {
      await createOrUpdateSubscriberProfile(data).then(response => {
        if (response.error) {
          this.$emit("onError");
          this.resetFormData(
            this.companyData?.introVideos?.length
              ? this.companyData.introVideos[0]
              : null
          );
        }
        if (response?.data?.introVideos) {
          this.resetFormData(
            response?.data?.introVideos?.length
              ? response?.data?.introVideos[0]
              : null
          );
        }
        this.isMediaSaving = false;
      });
    },
  },
};
</script>
